import { AnimationPropsBase } from '@unistocks/components/animations/animation-props';
import { AnimatedView, AnimatedViewProps } from '@unistocks/components/basic/animated-view';
import React, { PropsWithChildren, useEffect } from 'react';
import {
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming
} from 'react-native-reanimated';

export type PulseAnimationProps = PropsWithChildren<AnimationPropsBase & AnimatedViewProps>;

export const Pulse: React.FC<PulseAnimationProps> = ({
  enabled = true,
  scale = 1.1,
  duration = 1000,
  style,
  children,
  ...props
}) => {
  const pulseScale = useSharedValue(1);
  const pulseAnimation = useAnimatedStyle(() => {
    return {
      transform: [
        {
          scale: pulseScale.value
        }
      ]
    };
  });

  useEffect(() => {
    if (enabled) {
      pulseScale.value = withRepeat(
        withTiming(scale, {
          duration: duration * scale
        }),
        -1,
        true
      );
    } else {
      pulseScale.value = 1;
    }

    return () => cancelAnimation(pulseScale);
  }, [duration, enabled, pulseScale, scale]);

  return (
    <AnimatedView style={[style, pulseAnimation]} {...props}>
      {children}
    </AnimatedView>
  );
};

Pulse.displayName = 'PulseAnimation';
